export const HOST_POWER_STATUS = 'HOST_POWER_STATUS';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/hosts/powerStatus/PowerStatusConstants.js